<template>
    <div class="flats-crm-items-container flats-items-grid" v-if="flatsItems != null">
        <div class="flats-empty-msg" v-if="flatsEmptyMsg"><p>По данному запросу квартир в продаже не найдено</p></div>
        <div class="flats-items" v-if="!flatsEmptyMsg">
            <div class="flat-item" v-for="item in flatsItems" :key="item.id">
                <a href="#" @click.prevent="openCrmFlatModal(item)" class="item-link-main">
                    <div class="item-default item-img" v-if="item != null && item.id != null">
                        <div class="img-in" v-if="item.images.length > 0">
                            <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in item.images.filter(item => item.typeCode === '1')" :key="index">
                        </div>
                    </div>
                    <div class="item-desc">
                        <div class="item-title" v-if="projectHost != 'satpaev' && projectHost != 'nurly-dala2'">
                            <span>{{item.rooms}}-</span>{{flatsWords.flats_cards_info.flat_name}}, {{item.area}}м²
                        </div>
                        <div class="item-title" v-if="projectHost == 'satpaev' || projectHost == 'nurly-dala2'">
                            <span>{{item.apartmentCode}}-</span>{{flatsWords.flats_cards_info.flat_name}}, {{item.area}}м²
                        </div>
                        <div class="item-info">
                            <ul>
                                <li>
                                    <div class="left">
                                        {{flatsWords.flats_cards_info.flat_size}}
                                    </div>
                                    <div class="right">
                                        {{item.area}} <span>м²</span>
                                    </div>
                                </li>
                                <li class="price" v-if="salesCard.site_shablon_price_init == 'true' && item.showPricesOnSaleSite == true">
                                    <div class="left">
                                        {{flatsWords.flats_cards_info.flat_price}} м²
                                    </div>
                                    <div class="right">
                                        <span>от</span> {{getNumber(item.meterPrice)}} <span>тг.</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        {{flatsWords.flats_cards_info.flat_floor}}
                                    </div>
                                    <div class="right">
                                        {{item.floor}}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        {{flatsWords.flats_cards_info.flat_number}}
                                    </div>
                                    <div class="right">
                                        {{item.number}}
                                    </div>
                                </li>
                                <!-- <li>
                                    <div class="left">
                                        <span v-if="item.complexCode != 'SOH'">{{flatsWords.flats_cards_info.flat_bloom}}</span>
                                        <span v-if="item.complexCode == 'SOH'">{{flatsWords.flats_cards_info.flat_kvartal}}</span>
                                    </div>
                                    <div class="right" v-if="item.complexCode != 'DSV' && item.complexCode != 'LDM-3' && item.complexCode != 'SOH' && projectHost != 'lmgold' && projectHost != 'level' && projectHost != 'grandmonaco' && projectHost != 'elios'">
                                        {{getNumbersOfString(item.blockName)}}
                                    </div>
                                    <div class="right" v-if="item.complexCode == 'DSV' || projectHost == 'lmgold' || projectHost == 'level' || projectHost == 'grandmonaco' || projectHost == 'elios'">
                                        {{getNumbersOfBlockDiscovery(item.blockName)}}
                                    </div>
                                    <div class="right" v-if="item.complexCode == 'SOH'">
                                        {{getNumbersOfBlockSoho(item.blockName)}}
                                    </div>
                                </li> -->
                                <li>
                                    <div class="left">
                                        <span v-if="item.complexCode != 'SOH'">
                                            {{ flatsWords.flats_cards_info.flat_bloom }}
                                        </span>
                                        <span v-else>
                                            {{ flatsWords.flats_cards_info.flat_kvartal }}
                                        </span>
                                    </div>

                                    <!-- DEFAULT -->
                                    <div class="right"
                                        v-if="item.complexCode != 'DSV' 
                                            && projectHost != 'lmgold' 
                                            && item.complexCode != 'SOH' 
                                            && item.complexCode != 'MNC' 
                                            && projectHost != 'elios' 
                                            && projectHost != 'grandmonaco' 
                                            && projectHost != 'level'">
                                        {{ getNumbersOfString(item.blockName) }}
                                    </div>

                                    <!-- DSV -->
                                    <div class="right" v-if="item.complexCode == 'DSV'">
                                        {{ getNumbersOfBlockDiscovery(item.blockName) }}
                                    </div>

                                    <!-- LMGOLD -->
                                    <div class="right" v-if="projectHost == 'lmgold'">
                                        {{ getNumbersOfBlockLandmark(item.blockName, item.complexCode) }}
                                    </div>

                                    <!-- SOHO -->
                                    <div class="right" v-if="item.complexCode == 'SOH'">
                                        {{ getNumbersOfBlockSoho(item.blockName) }}
                                    </div>

                                    <!-- MONACO -->
                                    <div class="right" v-if="item.complexCode == 'MNC'">
                                        {{ getNumbersOfBlockMonaco(item.blockName) }}
                                    </div>

                                    <!-- ELIOS / GRANDMONACO / LEVEL -->
                                    <div class="right" v-if="projectHost == 'elios' || projectHost == 'grandmonaco' || projectHost == 'level'">
                                        {{ getNumbersOfBlockElios(item.blockName).spot }}
                                    </div>
                                </li>
                                <li v-if="getNumbersOfBlockElios(item.blockName).block">
                                    <div class="left">
                                        <span v-if="item.complexCode != 'SOH' 
                                            && item.complexCode != 'MNC' 
                                            && projectHost != 'elios' 
                                            && projectHost != 'grandmonaco' 
                                            && projectHost != 'level'">
                                            {{ flatsWords.flats_cards_info.flat_part }}
                                        </span>
                                        <span v-else>
                                            {{ flatsWords.flats_cards_info.flat_block }}
                                        </span>
                                    </div>

                                    <div class="right"
                                        v-if="projectHost == 'elios' 
                                            || projectHost == 'grandmonaco' 
                                            || projectHost == 'level'">
                                        {{ getNumbersOfBlockElios(item.blockName).block }}
                                    </div>

                                    <!-- старые кейсы -->
                                    <div class="right"
                                        v-if="projectHost == 'lmgold' 
                                            || item.complexCode == 'SOH' 
                                            || item.complexCode == 'MNC'">
                                        {{ getNumbersOfString(item.blockName) }}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </a>
                <div class="item-btns" v-if="salesCard.site_shablon_online_booking_init == 'true'">
                    <div>
                        <a 
                            :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=book'" class="bron" target="_blank" 
                            v-if="item.isApartmentReserved"
                            >{{flatsWords.flats_cards_info.flat_btn_book_name}}
                        </a>
                        <span v-else class="btn-off bron-off">{{flatsWords.flats_cards_info.flat_btn_book_name}}</span>
                        <a 
                        :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=by'" class="by" target="_blank" 
                            v-if="item.hasJointVentureAgreement"
                            >{{flatsWords.flats_cards_info.flat_btn_by_name}}
                        </a>
                        <span v-else class="btn-off by-off">{{flatsWords.flats_cards_info.flat_btn_by_name}}</span>
                    </div>
                    <div class="hypothec-btn" :class="{'disabled-link' : !item.hasMortgage}" v-if="salesCard.site_shablon_hypothec_init != null && salesCard.site_shablon_hypothec_init == 'true'">
                        <a 
                            :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=mortgage'" class="mortgage" target="_blank" 
                            v-if="item.hasMortgage"
                            >{{flatsWords.flats_cards_info.flat_btn_hypothec_online_name}}
                        </a>
                        <span v-else class="btn-off">{{ flatsWords.flats_cards_info.flat_btn_hypothec_online_name }}</span>
                    </div>
                    <!-- <div class="hypothec-btn" :class="{'disabled-link' : !item.hasMortgage}">
                        <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}, hash: '#flat-crm-card-online-payment'}" v-if="item.hasMortgage">{{ flatsPage.flats_cards_info.flat_btn_hypothec_online_name }}</router-link>
                        <span v-else class="btn-off">{{ flatsPage.flats_cards_info.flat_btn_hypothec_online_name }}</span>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-item',
        components: {
        },
        data () {
            return {
                projectHost: window.host,
                blockPart: null,
            }
        },
        methods: {
           getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockLandmark(str, code) {
                // console.log(str, code)
                if (code == 'LDM-3') {
                    this.blockPart = '3'
                } else {
                    this.blockPart = '5'
                } 
                // if (this.blockPart == null) {
                //     this.blockPart = str.split(',')[1];
                //     this.blockPart = parseInt(this.blockPart);
                // }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = this.blockPart.replace('Блок', '');
                    this.blockPart = this.blockPart.replace(/ /g, '');

                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getNumbersOfBlockMonaco(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = this.blockPart.replace('Блок', '');
                    this.blockPart = this.blockPart.replace(/ /g, '');

                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getNumbersOfBlockElios(str) {
                if (!str) return { spot: null, block: null }

                const parts = str.split(',')

                const spotNumber = (parts[0] || '')
                    .replace('Пятно', '')
                    .trim()

                let blockNumber = null

                if (parts[1]) {
                    blockNumber = parts[1]
                        .replace('Блок', '')
                        .trim()
                }

                return {
                    spot: spotNumber,
                    block: blockNumber
                }
            },
            openCrmFlatModal(arr) {
                this.$store.commit('modalData', arr);
                setTimeout(() => {
                    this.$modal.show('sales_land_flat_card_crm_modal');
                }, 300);
            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            openFormModal(param) {
                this.$store.commit('Open_Form_Modal', param);
            },
            checkConfirmPurchase(param, code, blockName) {
                // console.log(param, code, blockName)
                if (code != 'DSV' && code != 'LDM-3' && code != 'SOH' && code != 'MNC') {
                    blockName = this.getNumbersOfString(blockName);
                } else if (code == 'DSV') { 
                    blockName = parseInt(this.getNumbersOfBlockDiscovery(blockName));
                } 
                // else if (code == 'LDM') {
                //     blockName = parseInt(this.getNumbersOfBlockLandmark(blockName));
                // } else if (code == 'SOH') {
                //     blockName = this.getNumbersOfBlockSoho(blockName);
                // } else if (code == 'MNC') {
                //     blockName = this.getNumbersOfBlockMonaco(blockName);
                // }
                // console.log(blockName, this.blockPart)

                if (param == 'book') { //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        return false;
                    } 
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                } else if (param == 'by') { //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        return false;
                    }
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                } else {
                    return false;
                }
            },
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            flatsWords: 'loadFlatsWords',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // console.log(this.flatsPage, 'flatsPage')
            // this.$store.watch(
            //     (state) => state.flatsPage,
            //     (newValue) => {
            //         if (newValue) {
            //            this.filterSize();
            //             this.filterFloor();
            //         }
            //     }
            // );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-items.scss';
    @import '@/styles/components/flats-crm/flats-crm-items-main.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-respond.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-main-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-item-respond.scss';
</style>